import { Component, OnInit } from '@angular/core';
import { AuthService, BlockAbstractComponent, ParserService } from '@gallaghercp/core-frontend';
import { BreakpointObserver } from '@angular/cdk/layout';
import { APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-block-call-to-action',
    templateUrl: './block-call-to-action.component.html',
    standalone: false,
})
export class BlockCallToActionComponent extends BlockAbstractComponent implements OnInit {
    backgroundImage?: string;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected breakpoint: BreakpointObserver,
    ) {
        super(parser, auth);
    }

    override ngOnInit() {
        super.ngOnInit();
        this.breakpoint.observe(['(max-width: 992px)']).subscribe(result => {
            if (result.matches) {
                if (this.block.data.image_mobile_url) {
                    this.backgroundImage = APP_CONFIG.frontend + this.block.data.image_mobile_url;
                } else {
                    // fallback incase we don't have a mobile image
                    this.backgroundImage = APP_CONFIG.frontend + this.block.data.image_url;
                }
            } else {
                this.backgroundImage = APP_CONFIG.frontend + this.block.data.image_url;
            }
        });
    }
}
